import { callApi } from 'utils/api'

export const LOAD_ONBOARDING_PROGRESS = 'LOAD_ONBOARDING_PROGRESS'
export const FETCH_ONBOARDING_PROGRESS = 'FETCH_ONBOARDING_PROGRESS'

const loadOnboardingProgress = () => {
    return async (dispatch, getState) => {
        const state = getState()

        dispatch({ type: FETCH_ONBOARDING_PROGRESS })

        try {
            const res = await callApi('/onboarding', {
                method: 'GET',
                headers: {
                    Authorization: state.app.user.token
                }
            })

            dispatch({
                type: LOAD_ONBOARDING_PROGRESS,
                payload: res.body
            })

            return res.body
        } catch (error) {
            console.error('Error loading onboarding progress:', error)
            // On error, just stop loading without crashing
            dispatch({
                type: LOAD_ONBOARDING_PROGRESS,
                payload: {
                    steps: [],
                    completedCount: 0,
                    totalCount: 4,
                    percentage: 0,
                    isComplete: false
                }
            })
        }
    }
}

export default {
    loadOnboardingProgress
}
